<template>
  <div class="template-media-view">
    <MediaView
      :model-value="mediaUrls"
      :media-type="resolvedMediaType"
      :readonly="props.readonly"
      :is-slider="props.isSlider"
      :aspect-width="props.aspectWidth"
      :aspect-height="props.aspectHeight"
      @delete-item="handleDeleteItem"
    />
  </div>
</template>

<script setup lang="ts">
import { MediaView } from '~/entities/media'
import { MediaType } from '~/shared/const'
import { detectMediaTypeFromUrl } from '~/shared/lib'

interface Props {
  src?: string | string[] | null
  mediaType?: MediaType
  aspectWidth?: number
  aspectHeight?: number
  isSlider?: boolean
  readonly?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  src: () => [],
  aspectWidth: 1,
  aspectHeight: 1,
  isSlider: false,
  readonly: true,
})

const emit = defineEmits<{
  deleteItem: [index: number]
}>()

const mediaUrls = computed(() => {
  const val = props.src
  if (Array.isArray(val)) {
    return val.filter(Boolean)
  }
  if (val) {
    return [val]
  }
  return []
})

const resolvedMediaType = computed(() => {
  if (props.mediaType) {
    return props.mediaType
  }

  const url = mediaUrls.value[0]

  if (!url) {
    return MediaType.Image
  }

  return detectMediaTypeFromUrl(url)
})

function handleDeleteItem(index: number) {
  emit('deleteItem', index)
}
</script>

<style lang="scss" scoped>
.template-media-view {
  width: 100%;
  overflow: hidden;
  border-radius: var(--radius-md-alt);

  :deep(.editor-uploader) {
    height: 100%;
    width: 100%;
  }

  :deep(.media-image) {
    height: 100%;
    width: 100%;
  }

  :deep(.media-player) {
    height: 100%;
    width: 100%;
  }
}
</style>
